import React, { useEffect, useState } from "react";
import { Select, Spin } from "antd";
import { getCommisonDate } from "../../utils/API";

const { Option } = Select;

interface PayOutDateProps {
  selectedDate: string | undefined;
  handleDateChange: (dateString: string) => void;
}

const PayOutDate: React.FC<PayOutDateProps> = ({ selectedDate, handleDateChange }) => {
  const [commisonDate, setCommisonDate] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchCommisonDate = () => {
    setLoading(true);
    getCommisonDate()
      .then((response: any) => {
        const formattedDates = response.data.date.map((item: any) => {
          const dateObj = new Date(item.date);
          const formattedDate = dateObj.toLocaleString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            // hour: "2-digit",
            // minute: "2-digit",
            // hour12: true,
          });
          return {
            ...item,
            formattedDate: formattedDate,
          };
        });

        setCommisonDate(formattedDates);

        // Automatically select the first date if available
        if (formattedDates.length > 0) {
          const firstDate = formattedDates[0].formattedDate;
          handleDateChange(firstDate); // Notify parent of the initial selection
        }

        setLoading(false);
      })
      .catch((error: any) => {
        console.error(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchCommisonDate();
  }, []);

  return (
    <>
      <Select
        size="large"
        showSearch
        allowClear
        value={selectedDate} // Controlled by parent
        onChange={(value: string) => handleDateChange(value)} // Notify parent on change
        placeholder="Select Date"
        style={{ width: "100%" }}
        loading={loading}
      >
        {commisonDate.map((date: any) => (
          <Option key={date.formattedDate} value={date.formattedDate}>
            {date.formattedDate}
          </Option>
        ))}
      </Select>
    </>
  );
};

export default PayOutDate;
